module.exports = __webpack_public_path__ + "img/akechi.faa7ac26.jpg";